import { axiosCashJournalClient } from "./api";
import { MIDDLE_URL } from "./config";

export interface MetadataI {
  page: number,
  page_size: number,
  total_items: number,
  total_pages: number
}

export interface IResponseTrxReportData {
  responseCode: "Succeed" | "Failed",
  responseMessage: string,
}

export interface IGetTrxReportData {
  trx_id: string,
  trx_date: string,
  trx_desc: string,
  trx_text: string,
  employee_nip: string,
  employee_name: string,
  job_title: string,
  amount: string,
  gnlldr: string,
  sap_shkzg: string,
  status_trx: string,
  pool_id: string,
  area_id: string,
  area_name: string,
  company_code: string,
  company_relation: string,
  bank_account: string,
  bank_account_name: string,
  bank_account_number: string,
  plan_postdate: string,
  trx_type: string,
  trx_type_description: string,
  segment_code: string,
  segment_desc: string,
  department: {
    department: string,
    department_desc: string,
    department_cost: string,
    code_type: string,
    is_active: boolean,
  },
  trx_code: {
    trx_code: string,
    trx_desc: string,
    sap_bktxt: string,
    gnlldr: string,
    sap_shkzg: string,
  },
  trx_files: {
    file_text: string,
    file_count: string,
  },
  create_at: string,
}

export interface GetTrxReportParamsI {
  employee_email?: string,
  company_code?: string,
  department?: string,
  pool_id?: string,
  search?: string,
  start_date?: string,
  end_date?: string,
  sort_by?: string,
  sort_type?: string,
  page_number?: number,
  page_size?: number,
}

export interface TrxReportSummaryI {
  total_bon_amount: string,
  bon_amount_terbesar: string,
  bon_amount_terkecil: string,
}

export interface IGetTrxReportResponse {
  list_trx_report: IGetTrxReportData[],
  summary: TrxReportSummaryI,
  metadata: MetadataI,
}
export interface IPostTrxReportPayload {
  trx_id: string,
  create_by: string,
}

export interface IPostTrxReportDocPayload {
  start_date: string,
  end_date: string,
  pool_id: string,
  company_code: string,
  department: string,
  code_type: string,
}

export interface IResponseTrxReportDocData {
  response_code: "Succeed" | "Failed",
  response_message: string,
  file_source: {
    file_name: string,
    folder_name: string,
    file_url: string,
    content_type: string,
    bucket_name: string
  }
}

export const url = "/v1/smpltrx/reports";

export const getTrxReport = async (
  payload: GetTrxReportParamsI,
): Promise<IGetTrxReportResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}`,
    method: "GET",
    params: payload,
  });

  return data;
};

export const postTrxReport = async (
  payload: IPostTrxReportPayload,
): Promise<IResponseTrxReportData> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}`,
    method: "POST",
    data: payload,
  });

  return data;
};

export const getTrxReportDoc = async (
  payload: IPostTrxReportDocPayload,
): Promise<IResponseTrxReportDocData> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}/v1/smpltrx/report/download`,
    method: "POST",
    data: payload,
  });

  return data;
};
